const fonts = {
  init() {
    var WebFont = require('webfontloader');
    WebFont.load({
      typekit: {
        families: ['freight-sans-pro'],
        id: 'isv3fjj',
        async: true
      }
    });
  }
};

export default fonts;
